import type { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import copyTextToClipboard from '@/utils/copy-text';
import cn from '@/utils/merge-class-names';

interface Props {
  content: string;
  className?: string;
}

export default function CopyButton({ content, className, children }: PropsWithChildren<Props>) {
  const { t } = useTranslation();

  const handleCopy = () => {
    return copyTextToClipboard(content);
  };

  return (
    <button
      type='button'
      className={cn('rounded text-h3 bg-blue-500 text-neutral-0 px-2 h-8', className)}
      onClick={handleCopy}>
      {children ?? t('common.copy')}
    </button>
  );
}
